module.exports = __webpack_public_path__ + "img/valleint2.56e92730.png";